import layout from '../layout'
export default function makeModuleRoutes({
  contentType,
  components: { ModuleListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list/:CourseId`,
          component: ModuleListingContainer,
          props: {
            contentType
          }
        }
      ]
    }
  ];
}
